
 <div *ngIf="modalData?.data?.hereMapId">
  <header id="modal-v2-header">
        <div  class="text-content">
            <h4 class="modal-title4"><b>{{ modalData.heading }}</b></h4>
        </div>
    </header>
    
    <section class="modal-v2-body" style="overflow:hidden;">
        <div class="modal-v2-content">
            <app-here-map [appId]="$safeNavigationMigration(modalData?.data?.hereMapId)" [appCode]="$safeNavigationMigration(modalData?.data?.hereMapCode)"
                [mapOptions]="$safeNavigationMigration(modalData?.data?.mapOptions)" [startLabelData]="$safeNavigationMigration(modalData?.data?.startLabelData)"
                [endLabelData]="$safeNavigationMigration(modalData?.data?.endLabelData)"
                [currentTruckLocation]="$safeNavigationMigration(modalData?.data?.currentTruckLocation)" [ConfigData]="$safeNavigationMigration(modalData?.data?.mapConfig)"
                width="100%" height="575px">
            </app-here-map>
        </div>
    </section>
    <footer id="modal-v2-footer">
        <button *ngIf="modalData.actions" class="dhl-button dhl-button-primary" id="modal-v2-action-button"
            (click)="actionFunction($event)">
            {{ modalData.actionButtonText | translate }}

        </button>
    </footer>    
    
</div>
<div *ngIf="modalData.type === 'confirm'; else common" style="position: relative;" class="modal-v2-content-wrapper">
    <header id="modal-v2-header">
        <div *ngIf="modalData.heading" class="text-content">
            <h4 class="modal-title2">{{ modalData.heading }}</h4>
        </div>
        <div class="modal-v2-title">
            <div *ngIf="modalData.imgIcon" class="action-icon"><img [src]="modalData.imgIcon" style="height: 40px;
                width: 40px;"></div>
                <div class="text-content">
                    <p>{{ modalData.description | translate }}</p>
                </div>
                <div *ngIf="!modalData.noCancelButton" class="cancel-icon" (click)="closeModal($event)"></div>
            </div>
    </header>
    
    <section class="modal-v2-body">
        <div class="modal-v2-content">

        </div>
    </section>
    <footer id="modal-v2-footer">
        <button *ngIf="modalData.showCancel" class="dhl-button dhl-text-button" (click)="closeModal($event)">
            {{enum.BUTTONS.BUTTONCANCEL | translate}}
        </button>
		<button *ngIf="modalData.secondaryAction" class="dhl-button dhl-text-button" (click)="closeModal($event)">
            {{modalData.secondaryAction}}
        </button>
        <button *ngIf="modalData.actions" class="dhl-button dhl-button-primary" id="modal-v2-action-button"
            (click)="actionFunction($event)">
            {{ modalData.actionButtonText | translate }}

        </button>
    </footer>
</div>

<ng-template #common>
    <div *ngIf="config?.modalControls" class="modal-controls-wrapper">
        <header id="modal-header">
            <h1 id="modal-title" class="title"> {{ modalData.title }}</h1>
			<h4 *ngIf="modalData.subtitle" id="modal-subtitle" class="subtitle"> {{ modalData.subtitle }}</h4>
			<h4 *ngIf="modalData.Information" id="modal-information" class="Information"> {{ modalData.Information }}</h4>
        </header>
        <section id="modal-body" [class.modal-scrollable]="config?.scrollableModal">
            <div [formGroup]="formGroup" fxFlex>
                <div class="row">
                    <div *ngFor="let control of config.modalControls" [ngClass]="getColsClass(control.cols)">
                        <app-form-field [configData]="control" [frmGroup]="formGroup"></app-form-field>
                    </div>
                </div>
                <div *ngIf="config.warningText2" id="modal-information" class="Information warningText2">
                    {{config.warningText2 | translate}}
                </div>
                <div *ngIf="config.warningText" class="modal-v2-content">
                    <div class="action-icon"><img [src]="modalData.imgIcon"></div>
                    <div class="text-content">
                        <p>{{ config.warningText | translate }}</p>
                    </div>
                </div>
                <app-generic-inline-messages *ngIf="modalData?.config?.allowInlineMessage"></app-generic-inline-messages>
            </div>
        </section>
        <footer style="text-align: right; flex-shrink: 0;">
            <ng-container *ngIf="config.modalActions; else defaultFooter">
                <ng-container *ngFor="let action of config.modalActions">
                    <button style=" margin-top:25px;" class="dhl-button" [disabled]="(formGroup.invalid && action.type==='submit') || action.disabled"
                       [ngClass]="'dhl-button-' + action.view.buttonType" (click)="onCloseModalEvent(action.type, formGroup, modalData, $event)">
                        {{action.view.label}}
                    </button>
                </ng-container>
            </ng-container>
        </footer>
        <ng-template id="modal-footer" style="text-align: right;" #defaultFooter>
            <button style="margin-right: 25px;" class="dhl-button dhl-button-secondary" (click)="closeModal($event)">
                {{modalData.cancelButtonText ? modalData.cancelButtonText : 'Cancel'}}
            </button>
            <button *ngIf="config.name !== 'orderNotes' && config.name !== 'escalationNotesHistory'" class="dhl-button dhl-button-primary primary-button-v2" style="margin-right: 0;" id="modal-action-button"
            [disabled]="(config.name !== 'pickuporder' && config.name !== 'originDetails_pickupContacted') ? (formGroup.pristine || formGroup.invalid || formGroup.untouched || config.warningText2) : false"
                (click)="onSubmitEvent('submit', formGroup, modalData)">
                {{modalData.actionButtonText ? modalData.actionButtonText : 'Save'}}
            </button>
        </ng-template>
    </div>
</ng-template>
<main *ngIf="modalData.type === 'TABLE' " class="modal-content-box">
    <header>
        <h3>{{modalData.title}}</h3>
    </header>
    <article>
        <div *ngIf="modalData.description">{{modalData.description}}</div>
        <div *ngIf="modalData.config?.component === 'TABLE_SIMPLE_V2' ">
            <!-- Here goes the component...    -->
            <app-table-simple-v2 [configData]="modalData.config.componentConfig" [data]="modalData.data"></app-table-simple-v2>
        </div>
    </article>
    <div style="
        margin: 18px 0;
        border-top: 1px solid #ccc;">
    </div>
    <footer class="footer">
        <div>
            <button class="dhl-button dhl-button-primary"
            (click)="actionFunction($event)">
            Close
        </button>
        </div>
    </footer>
</main>
